import React from 'react';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';

const slideUp = keyframes`
	from {
		transform: translateY(100%);
	}
	to {
		transform: translateY(0);
	}
`;

const Backdrop = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			background: rgba(0, 0, 0, 0.65);
			position: fixed;
			left: 0px;
			top: 0px;
			right: 0px;
			bottom: 0px;
			z-index: 3;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			background: rgba(0, 0, 0, 0.65);
			position: fixed;
			left: 0px;
			top: 0px;
			right: 0px;
			bottom: 0px;
			z-index: 3;
		`
	}
`;

const Container = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			border-top-left-radius: 26px;
			border-top-right-radius: 26px;
			background: #FFFFFF;
			position: fixed;
			left: 0px;
			right: 0px;
			bottom: 0px;
			padding: 0px 0px 100px 0px;
			animation: ${slideUp} 0.4s ease-out forwards;
			z-index: 3;
			height: 100vh;
			max-height: 70vh;
			overflow: auto;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			border-top-left-radius: 26px;
			border-top-right-radius: 26px;
			background: #FFFFFF;
			position: fixed;
			left: 0px;
			right: 0px;
			bottom: 0px;
			padding: 0px 0px 25px 0px;
			animation: ${slideUp} 0.4s ease-out forwards;
			z-index: 3;
			max-height: 80vh;
			overflow: auto;
		`
	}
`;

const CloseContainer = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			display: flex;
			align-items: end;
			justify-content: end;
			padding: 15px 16px 15px 16px;
			margin: 0px;
			position: sticky;
			top: 0px;
			background: #fff;		
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			display: flex;
			align-items: end;
			justify-content: end;
			padding: 15px 16px 15px 16px;
			margin: 0px;
			position: sticky;
			top: 0px;
			background: #fff;
		`
	}	
`;

const CloseText = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
			font-size: 16px;
			color: #0071D1;
			margin: 0px 4px 0px 0px;
			line-height: 20px;			
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
			font-size: 16px;
			color: #0071D1;
			margin: 0px 4px 0px 0px;
			line-height: 20px;	
		`
	}	
`;

const CloseIcon = styled.img`
	${props => props.$isContainerTelcel &&
		css`
			width: 24px;
			height: 24px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			width: 24px;
			height: 24px;
		`
	}	
`;

const FixedBottom = styled.div`
	${props => props.$isContainerTelcel && 
		css`
			background: #fff;
			position: fixed;
			bottom: ${props => props.$canHideNativeNavbar ? "30px" : "12px"};
			left: 0px;
			right: 0px;
			padding: ${props => props.$canHideNativeNavbar ? "24px 16px 40px 16px" : "24px 16px 24px 16px"};
			z-index: 4;
			border-top: 1px solid #BABABA;
			box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.08);
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			background: #fff;
			position: fixed;
			bottom: ${props => props.$canHideNativeNavbar ? "30px" : "12px"};
			left: 0px;
			right: 0px;
			padding: ${props => props.$canHideNativeNavbar ? "24px 16px 40px 16px" : "24px 16px 24px 16px"};
			z-index: 4;
		`
	}
`;

const Button = styled.button`
	${props => props.$isContainerTelcel &&
		css`
			background: #7B1FA2;
			border: 1px solid #7B1FA2;
			border-radius: 100px;
			color: #ffffff;
			display: block;
			font-family: AMX-Bold;
			font-size: 16px;
			padding: 10px 15px 7px 15px;
			width: 100%;
		`
	}

	${props => props.$bundleName && props.$bundleName === BUNDLE_CLARO_PAY &&
		css``
	}
`;

const ModalLegales = ({ url, handleOnClick, isContainerTelcel }) => {

	React.useEffect(() => {
		const handleMessage = (event) => {
			if (event.data && event.data.url) {
				ClaroSDKService.openExternalLinks(event.data.url)
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, []);
	
	const getCloseIcon = () =>{
		switch (isContainerTelcel) {
			case true:
				return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "payment_methods_list_close_icon.png";
		
			default:
				return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "payment_methods_list_close_icon.png";
		}
	}
	
	return (
		<>
			<Backdrop $isContainerTelcel={isContainerTelcel}>
				<Container $isContainerTelcel={isContainerTelcel}>
					<CloseContainer $isContainerTelcel={isContainerTelcel}>
						<CloseText 
							$isContainerTelcel={isContainerTelcel}
							onClick={handleOnClick}
						>
							Cerrar
						</CloseText>
						<CloseIcon
							$isContainerTelcel={isContainerTelcel}
							src={getCloseIcon()}
							alt="close-icon"
							onClick={handleOnClick}
						/>						
					</CloseContainer>
					<iframe 
						style={{ 
							padding: '0px 16px', 
							height: '100%', 
							width: '100%',  
							boxSizing: 'border-box',
							border: 'none',
						}} 
						src={url}
					/>
				</Container>
			</Backdrop>
			<FixedBottom $isContainerTelcel={isContainerTelcel}>
				<Button 
					$isContainerTelcel={isContainerTelcel}
					onClick={handleOnClick}>
					Entendido
				</Button>
			</FixedBottom>
		</>
	)
}

const mapStateToProps = (state) => {
	const { payments } = state;
	const isContainerTelcel = payments.isContainerTelcel;
	return {
		isContainerTelcel,
	}
}

export default connect(mapStateToProps)(ModalLegales);
